/** Picks the backend: mock (default) or the real HTTP API, by `VITE_USE_MOCK`. */
import type { ChatApi } from './client'
import { HttpChatApi } from './http'
import { MockChatApi } from './mock'
import { connectMock, connectSocket, type RealtimeConnection, type RealtimeHandlers } from './realtime'

export const useMock = (import.meta.env.VITE_USE_MOCK ?? 'true').trim().toLowerCase() !== 'false'
// Empty = same origin (production: web + API behind one domain; dev: Vite proxies /api and /auth).
const base = (import.meta.env.VITE_API_BASE ?? '').trim()

let current: ChatApi | null = null

export function getApi(): ChatApi {
  if (!current) current = useMock ? new MockChatApi() : new HttpChatApi(base)
  return current
}

/** Tests inject their own backend. */
export function setApi(api: ChatApi | null): void {
  current = api
}

export function connectRealtime(h: RealtimeHandlers): RealtimeConnection {
  const api = getApi()
  if (api instanceof MockChatApi) return connectMock(api, h)
  return connectSocket(base, h)
}

export type { ChatApi }
